module.exports = __webpack_public_path__ + "img/privacyPolicy.a2b1d277.jpg";